$(document).ready(function (e) {
    $("#import_list_of_items").on('click', function (e) {
        e.preventDefault()
        $("#modal-import-list_items").modal('show')
    })

    $('#btn-importar-precios').on('click', function () {
        const formData = new FormData($('#form-import-precios')[0]);
        let route = "precios.importar";
        $.ajax({
            url: route,
            method: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            beforeSend: function () {
                $('#btn-importar-precios').prop('disabled', true).text('Importando...');
            },
            success: function (response) {
                if (response.success === true) {
                    alertSuccess(response.msg)
                    document.getElementById('div_price_table').innerHTML = response.view;
                    $('#modal-import-list_items').modal('hide');
                }else{
                    alertError(response.msg)
                }



            },
            error: function (xhr) {
                const errores = xhr.responseJSON?.errors;
                if (errores) {
                    alert(Object.values(errores).flat().join('\n'));
                } else {
                    alert('Ocurrió un error al importar.');
                }
            },
            complete: function () {
                $('#btn-importar-precios').prop('disabled', false).html('<i class="fas fa-file-import mr-1"></i> Importar');
            }
        });
    });

    $('#archivo_excel').on('change', function () {
        const nombre = $(this).val().split('\\').pop();
        $(this).next('.custom-file-label').text(nombre || 'Elegir archivo...');
    });
})
